import { Component, type ErrorInfo, type ReactNode } from "react";
import type { HomeWidget, HomeWidgetDescriptor } from "../../api/hub/home";
import { WidgetContent } from "./WidgetContents";
import { KnowledgeSearch } from "./KnowledgeSearch";
class WidgetGuard extends Component<
  { children: ReactNode; resetKey: string },
  { failed: boolean }
> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(_error: Error, _info: ErrorInfo) {
    /* One renderer cannot remove the rest of the work desk. */
  }
  componentDidUpdate(previous: { resetKey: string }) {
    if (previous.resetKey !== this.props.resetKey && this.state.failed) {
      this.setState({ failed: false });
    }
  }
  render() {
    return this.state.failed
      ? (
        <div className="home-error" role="alert">
          <p>这个部件没能显示，其他部件仍可使用。</p>
          <button onClick={() => this.setState({ failed: false })}>
            重试部件
          </button>
        </div>
      )
      : this.props.children;
  }
}
export function widgetTitle(
  widget: HomeWidget,
  descriptor?: HomeWidgetDescriptor,
) {
  return typeof widget.config.title === "string" && widget.config.title
    ? widget.config.title
    : descriptor?.name ??
      (widget.type.startsWith("app:") ? "应用作品" : "未知部件");
}
export function WidgetBody(
  { widget, descriptor, sharedOnly = false }: {
    widget: HomeWidget;
    descriptor?: HomeWidgetDescriptor;
    sharedOnly?: boolean;
  },
) {
  if (!descriptor) {
    return (
      <div className="home-error" role="alert">
        <p>这个部件已停用或不在当前权限范围内。编辑主页可移除它。</p>
      </div>
    );
  }
  return (
    <WidgetGuard
      resetKey={widget.id + JSON.stringify(widget.config) + String(sharedOnly)}
    >
      {widget.type === "native:kb-search"
        ? <KnowledgeSearch widget={widget} />
        : <WidgetContent widget={widget} sharedOnly={sharedOnly} />}
    </WidgetGuard>
  );
}
